/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Labels_ChangedInputs */

const en_toast_labels_changed = /** @type {(inputs: Toast_Labels_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields and labels changed`)
};

const de_toast_labels_changed = /** @type {(inputs: Toast_Labels_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder und Labels geändert`)
};

/**
* | output |
* | --- |
* | "Fields and labels changed" |
*
* @param {Toast_Labels_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_labels_changed = /** @type {((inputs?: Toast_Labels_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Labels_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_labels_changed(inputs)
	return en_toast_labels_changed(inputs)
});